export const isDevMode = import.meta.env.VITE_NODE_ENV !== 'production';
